
import { updateMyPassword } from '@/api/user';
import { Form } from 'element-ui';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'ChangePasswordForm',
  components: {
  },
})
export default class extends Vue {
  private form: any = {
    password: '',
    newPassword: '',
    newPasswordCheck: '',
  }

  private validatePasswordCheck = (rule:any, value:any, callback:any) => {
    if (value !== (this.$refs.form as any).model.newPassword) {
      callback(new Error('비밀번호가 일치하지 않습니다.'));
    } else {
      callback();
    }
  };

  private rules: any = {
    password: [
      { required: true, message: '기존 비밀번호를 입력하세요.', trigger: ['blur', 'change'] },
    ],
    newPassword: [
      { required: true, message: '변경할 비밀번호를 입력하세요.', trigger: ['blur', 'change'] },
      { min: 8, max: 20, message: '비밀번호는 최소 8자, 최대 20자입니다.' },
    ],
    newPasswordCheck: [
      { required: true, message: '비밀번호 확인을 입력하세요.', trigger: ['blur', 'change'] },
      { validator: this.validatePasswordCheck, trigger: ['blur', 'change'] },
    ],
  }

  private handleSubmit() {
    (this.$refs.form as Form).validate((valid: boolean) => {
      if (valid) {
        updateMyPassword(this.form).then(() => {
          this.$message.success('계정 비밀번호가 변경되었습니다.');
          this.$emit('close');
        });
      }
    });
  }

  private handleClose() {
    this.$emit('close');
  }
}
